/// <amd-module name="TFS/Admin/Common/Util/TypeConverters" />
import { IVssPageContext } from "VSS/Platform/Context";
import { GraphMember, GraphGroup } from "VSS/Platform/Contracts/Graph";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { getIdentityImageUrl } from "VSS/Platform/Identity";
import { IIdentity } from "VSSUI/IdentityPicker";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import * as Constants from "TFS/Admin/Common/Constants/Constants";
import { IEntityType } from "../Constants/Constants";

export function convertGraphMemberToIIdentity(pageContext: IVssPageContext, graphMember: GraphMember, avoidCache: boolean = false): IIdentity {
    if (!graphMember) {
        return {} as IIdentity;
    }

    return {
        localId: graphMember.originId,
        originId: graphMember.originId,
        displayName: graphMember.displayName,
        image:
            getIdentityImageUrl(pageContext, { descriptor: graphMember.descriptor } as IdentityRef) + (avoidCache ? `?${new Date().getTime()}` : ""),
        subjectDescriptor: graphMember.descriptor,
        entityType: graphMember.subjectKind,
        mail: graphMember.mailAddress
    } as IIdentity;
}

export function convertIIdentityToGraphMember(identity: IIdentity): GraphMember {
    if (!identity) {
        return {} as GraphMember;
    }

    return {
        originId: identity.localId || identity.originId,
        displayName:
            localeIgnoreCaseComparer(identity.entityType, Constants.group) == 0 && identity.samAccountName
                ? identity.samAccountName
                : identity.displayName,
        descriptor: identity.subjectDescriptor,
        subjectKind: identity.entityType,
        mailAddress: identity.mail,
        principalName: identity.displayName
    } as GraphMember;
}

export function convertGraphGroupToIIdentity(pageContext: IVssPageContext, graphGroup: GraphGroup, avoidCache: boolean = false): IIdentity {
    if (!graphGroup) {
        return {} as IIdentity;
    }

    return {
        localId: graphGroup.originId,
        originId: graphGroup.originId,
        displayName: graphGroup.principalName, // For Org/proj Settings, we are explicitly using principal name in place of display name
        image:
            getIdentityImageUrl(pageContext, { descriptor: graphGroup.descriptor } as IdentityRef) + (avoidCache ? `?${new Date().getTime()}` : ""),
        subjectDescriptor: graphGroup.descriptor,
        entityType: graphGroup.subjectKind,
        mail: "",
        originDirectory: ""
    } as IIdentity;
}

export function convertIdentityRefToGraphMember(identityRef: IdentityRef): GraphMember {
    if (!identityRef) {
        return {} as GraphMember;
    }
    const { displayName } = identityRef;
    return {
        ...identityRef,
        subjectKind: identityRef.isContainer ? IEntityType.Group : IEntityType.User,
        principalName: displayName,
        displayName: displayName.substring(displayName.indexOf('\\') + 1),
        mailAddress: identityRef.isContainer ? undefined : identityRef.uniqueName
    } as unknown as GraphMember;
}